import axios from "axios";

const validateEmail = async (email) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_URL}/api/auth/verify-email`,
      { email },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      }
    );

    return response.data.status === true && response.data.data === true;
  } catch (err) {
    console.error("Email validation error:", err);
    return false;
  }
};

export default validateEmail;
